
  import { Component, Vue } from 'vue-property-decorator';
  import { Client, IClientSearchResultModel, ClientSearchResultModel } from '@/services/api.service';
  import * as QueryUtils from '@/utilities/querystring.utils';
  @Component
  export default class ClientSearch extends Vue {
    public searchCriteria: string = '';
    public searchResults: ClientSearchResultModel[] = [];

    protected mounted() {
      let executeSearch: boolean = false;

      const q: string = this.$route.query.q as string;
      if (q !== null && q !== undefined) {
        this.searchCriteria = q as string;
        executeSearch = true;
      }

      // We execute the search on mounted if we
      // have parsed up any useful parameters
      if (executeSearch) {
        this.searchClients(true);
      }
    }

    private searchClients(bypassHistoryPush: boolean) {
      if ((this.searchCriteria || '') !== '') {

        if (!bypassHistoryPush) {
        // Make sure that we have a new route, and aren't just pushing
        // the same old route query data onto the history, as that
        // gives some issues like navigation duplicated errors
        if (
          !QueryUtils.isQueryObjectMatch(this.$route.query, {
            q: this.searchCriteria,
          })
        ) {
          console.log('Search pushing history:', {
            q: this.searchCriteria,
          });
          this.$router.push({
            path: 'clients',
            query: { q: this.searchCriteria }
          });
          // If we are pushing the history, then by pushing it,
          // it will remount the view, which in turn will execute
          // the search. So we can bail out here and not continue
          // to execute the search as the mounted method will do so
          return;
        }
      }
        // @ts-ignore
        this.$Progress.start();
        this.searchResults = [];
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        clientService.searchClients(this.searchCriteria).then(data => {
          if (data !== null && data.length > 0) {
            // push the results into the list
            this.searchResults = data;
          } else {
            // Pop some toast
            // @ts-ignore
            this.$awn.info('No matching clients were found');
          }
          // @ts-ignore
          this.$Progress.finish();
        });
      } else {
        // Empty search criteria, so toaster?
      }
    }

    // private isQueryObjectMatch(currentQuery: any, newQuery: any) {
    //   if (currentQuery !== null && currentQuery !== undefined) {
    //     if (currentQuery.q !== newQuery.q) {
    //       return false;
    //     }
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  }
